import { MILLISECONDS_IN_MINUTE } from "../unit-utils/time";

export function minutesBetween(startDate: Date, endDate: Date): number {
    return Math.round(Math.abs((startDate.getTime() - endDate.getTime()) / MILLISECONDS_IN_MINUTE));
}
